// crewbit-admin/src/hooks/useDisputeEscalations.ts
//
// Tier 2 Phase E §WorldClass.5 — Stripe Connect deep substrate.
// Admin paired hook for get_dispute_escalations RPC (Migration 276).
// Mirrors crewbit-mobile/hooks/useDisputeEscalations.ts.

import { useCallback } from 'react';
import { callMoneyRpc, type MoneyRpcResult } from '../lib/moneyRpc';
import type { DisputeEscalation, DisputeCounts, DisputeStatus } from '../types/disputes';

export interface DisputeEscalationsArgs {
  businessId: string;
  statusFilter?: DisputeStatus | null;
  limit?: number;
}

export type DisputeEscalationsHookResult = MoneyRpcResult<{
  business_id: string;
  disputes: DisputeEscalation[];
  counts: DisputeCounts;
}>;

export function useDisputeEscalations() {
  return useCallback(
    async (args: DisputeEscalationsArgs): Promise<DisputeEscalationsHookResult> => {
      return callMoneyRpc<{
        business_id: string;
        disputes: DisputeEscalation[];
        counts: DisputeCounts;
      }>('get_dispute_escalations', {
        p_business_id: args.businessId,
        p_status_filter: args.statusFilter ?? null,
        p_limit: args.limit ?? 50,
      });
    },
    [],
  );
}
